import { Injectable } from '@angular/core';
import { LawSuitReqApisModel, TempCreatRefApisModel } from '../../models/lawsuit/lawsuit';
import { LawSuitReqModel, TempCreatRefModel } from '../../view-models/lawsuit';
import { Mapper } from '../mapper';

@Injectable({
    providedIn: 'root'
})
export class SaveTempRefMapper implements Mapper<LawSuitReqApisModel, LawSuitReqModel>  {
    constructor(

    ) { }
    mapForm(param: LawSuitReqApisModel): LawSuitReqModel {
        return null!
    }

    mapTo(param: LawSuitReqModel): LawSuitReqApisModel {
        return {
            refCode: param.refCode,
            filingAS: param.filingAS,
            filingaS_DOCS: param.filingASDOCS,
            filingGroup: param.filingGroup,
            reQ_ID: param.reQID,
        }
    }

} 